import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './JoinLocationSection.scss';

const JoinLocationSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const slideLeft = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, x: -40 },
              whileInView: { opacity: 1, x: 0 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.2, ease: EASE_OUT_EXPO },
          };

    return (
        <section className="join-location">
            <div className="join-location__outer">
                <div className="join-location__container">
                    <div className="join-location__grid">

                        <motion.div className="join-location__content" {...slideLeft}>
                            <h2 className="join-location__title">{t('join_location_title')}</h2>
                        </motion.div>

                        <motion.div className="join-location__info" {...fadeUp(0.15)}>
                            <div className="join-location__info-box">
                                <div className="join-location__item">
                                    <h3 className="join-location__subtitle">{t('service_times')}</h3>
                                    <p className="join-location__text">
                                        {t('join_location_service_detail')}
                                    </p>
                                </div>
                                <div className="join-location__item">
                                    <h3 className="join-location__subtitle">{t('address')}</h3>
                                    <p className="join-location__text">
                                        {t('church_address')}
                                    </p>
                                </div>
                                <a
                                    href="https://www.google.com/maps/dir//920+Trenton+Rd+Fairless+Hills,+PA+19030+USA/@40.1857575,-74.832338,19z/data=!4m5!4m4!1m0!1m2!1m1!1s0x89c151261b198351:0xa313c99eac9a59ee"
                                    className="join-location__button"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('join_location_get_direction')}
                                </a>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JoinLocationSection;